export const CapabilitiesStateKeys = Object.freeze({
  IS_MOBILE: 'IS_MOBILE',
  IS_TABLET: 'IS_TABLET',
} as const);

export const CapabilitiesActions = Object.freeze({
  SET_CAPABILITIES: 'SET_CAPABILITIES',
} as const);
